import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';

import CustomerProductsList from '../components/rts/CustomerProducts/CustomerProductsList';
import CustomerProductsHeader from '../components/rts/CustomerProducts/CustomerProductsHeader';
import CustomerProductsFilter from '../components/rts/CustomerProducts/CustomerProductsFilter';

import { useSessionContext } from '../contexts/SessionContext';

export default function CustomerProductsPage( props ){
    //console.debug("RTS Break CustomerProductsPage");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [filter, setFilter] = useState();
    const [data, setData] = useState([]);


    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Products/GetProductsSummary";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status == 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]); 


    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'CustomerProductsPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({customer:sessionCustomer.customer, hierarchy:null});
            fetchData({customer:sessionCustomer.customer, hierarchy:null})
        }
    }, [props, user, sessionCustomer, curFilter, fetchData]); 


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <Box>
            <CustomerProductsHeader />
            {/* <CustomerProductsFilter filter={filter} setFilterFx={setFilter}/> */}
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <CustomerProductsList data={data} />
            </Box>
        </Box>
    );
}
